import { ApiLogEntry } from "./types";

// Generate a copyable cURL equivalent for a logged request. The bearer
// token is redacted to a shell variable placeholder so pastes don't leak
// the user's real key into chat or snippets.
export function toCurl(entry: ApiLogEntry): string {
  const parts: string[] = ["curl"];
  if (entry.method !== "GET") parts.push(`-X ${entry.method}`);

  for (const [name, value] of Object.entries(entry.requestHeaders)) {
    if (!value) continue;
    const displayed = name.toLowerCase() === "authorization"
      ? 'Authorization: Bearer $HPAC_API_KEY'
      : `${name}: ${value}`;
    parts.push(`-H ${shellQuote(displayed)}`);
  }

  if (entry.multipartSummary) {
    // Show a placeholder rather than attempting to serialise a FormData body
    parts.push(`-F ${shellQuote(entry.multipartSummary)}`);
  } else if (entry.requestBody) {
    parts.push(`--data-raw ${shellQuote(entry.requestBody)}`);
  }

  parts.push(shellQuote(entry.url));

  return parts.join(" \\\n  ");
}

function shellQuote(s: string): string {
  return `'${s.replace(/'/g, "'\\''")}'`;
}
